
import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://wdsxfucrfslpulxvknjv.supabase.co'
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indkc3hmdWNyZnNscHVseHZrbmp2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDA3Mjc4NDYsImV4cCI6MjAxNjMwMzg0Nn0.0QgitSa0qsPW5zWE0Tw3dhtUMyrMLV-IF4kV-UCNKgc"
const supabase = createClient(supabaseUrl, supabaseKey)
export default supabase